import React from "react";
import { NumericFormat } from "react-number-format";
import Race from "./Race";
import ProgressBar from "../ProgressBar";

import { ReactComponent as ExpandIcon } from "../images/icon-expand_latest.svg";
import { ReactComponent as CollapseIcon } from "../images/icon-collapse_latest.svg";
import placeholder from '../images/placeholder.jpg';
import { getOverride, getEstimatedVotesPercent } from "../helpers";

const RaceCard = React.memo(({
  race,
  widget: options,
  onToggle,
  expanded
}) => {

  // we now need to check if any candidate has an image rather than all
  const shouldShowImages = race.candidates.some(
    candidate => candidate.image && candidate.image !== ""
  );

  const thereIsAWinner =
    race.candidates.some(candidate => getOverride(candidate, "winner") === true) &&
    options.showWinner;
  const thereIsAnIncumbent = race.candidates.some(
      candidate => getOverride(candidate, "incumbent") === true
  );


  const name = getOverride(race, "name");
  const description = getOverride(race, "description");
  const filteredDescription = description && description.split('#')[0];
  const precinctsReporting = getOverride(race, "precinctsReporting");
  const precinctsTotal = getOverride(race, "precinctsTotal");
  const votesCast = getOverride(race, "votesCast");
  var decodedName = name.replace(/&quot;/g, '"');
  decodedName = decodedName.replace(/&amp;/g, '&');

  // AP estimated expected vote percentage (eevp), whole number or null when blank. Never calculated; precinctsPercent is not used.
  const reportingPercentage = getEstimatedVotesPercent(race);
  const hasPercent = reportingPercentage !== null;

  // Hide the precinct reporting block entirely when there is no precinct data.
  const hasPrecinctData = Number(precinctsTotal) > 0;
  const showPrecincts = options.showPrecincts && hasPrecinctData;

  // If the producer chooses to sort by votes - "sortCandidatesByVotes"
  if (options.sortCandidatesByVotes) {
    race.candidates.sort((a,b) => parseInt(getOverride(b, "votes")) - parseInt(getOverride(a, "votes")))
  }

  return (
    <div>
      <div
        className={
          "widget race" +
          (showPrecincts ? "" : " no-precincts") +
          (expanded ? " expanded" : " collapsed")
        }
      >
        <div
          className="race-title"
          onClick={onToggle}
        >
          <div className="race-title-name">
            <span>{decodedName}</span>
          </div>

          {expanded ? (
            <ExpandIcon className="expand-icon" title="Expand" />
          ) : (
            <CollapseIcon className="expand-icon" title="Collapse" />
          )}
        </div>

        {description && filteredDescription && (
          <div className="race-description">
            <p>{filteredDescription}</p>
          </div>
        )}

        <div className={`race-cards${thereIsAnIncumbent ? " has-incumbent" : ""}${shouldShowImages ? " show-images" : ""}`}>
          <Race
            result={race.candidates}
            shouldShowImages={shouldShowImages}
            thereIsAWinner={thereIsAWinner}
            options={options}
            votesCast={votesCast}
          />
          <div
            className={
              "grid-row totals" +
              (shouldShowImages ? "" : " no-image") + 
              (options.showVotes ? "" : " no-votes")
            }
          >
            {shouldShowImages && (
              <div className="race-total-image">
                <figure>
                  <img src={placeholder} alt="placeholder" />
                </figure>
              </div>
            )}
            {options.showVotes && (
              <div className="race-total-label">Total</div>
            )}
            {options.showVotes && (
              <div className="race-total-votes">
                <NumericFormat
                  value={votesCast}
                  displayType={"text"}
                  thousandSeparator={true}
                />{" "}
                votes
              </div>
            )}
          </div>
        </div>
        {showPrecincts && (
          <div
            className={
              "race-precincts-reporting" +
              (options.showPercentOfPrecincts ? "" : " no-percent-precincts")
            }
          >
            {options.showPercentOfPrecincts && hasPercent && (
              <div className="grid-row progress-bar-and-percentage-container">
                <div></div>
                <div className="progress-bar-with-percentage">
                  <ProgressBar
                    percentage={reportingPercentage}
                  />
                </div>
                <div className="race-precincts-reporting-percentage progress-bar-percentage">
                  {reportingPercentage}%
                </div>
              </div>
            )}
            {options.showTotalPrecincts && (
              <div className="race-precincts-reporting-text">
                <NumericFormat
                  value={precinctsReporting}
                  displayType={"text"}
                  thousandSeparator={true}
                />{" "}
                of{" "}
                <NumericFormat
                  value={precinctsTotal}
                  displayType={"text"}
                  thousandSeparator={true}
                />{" "}
                Precincts Reporting
              </div>
            )}
            {!options.showTotalPrecincts && (
              <span>Precincts Reporting</span>
            )}
          </div>
        )}
      </div>
    </div>
  );
});

export default RaceCard;
